const menuLinkArrowVariants = {
    open: {
      x: 0,
    },
    closed: {
      x: -4,
    },
  };

  export default menuLinkArrowVariants;